import queryString from 'query-string'
import { Navigate, useSearchParams } from 'react-router-dom'
import { savedTokens } from 'src/auth'
import { Aside, ErrorNotLoggedIn, Main } from 'src/components'
import LoggedInNavigate from '../Marketplace/LoggedInNavigate'

// TODO: depending on saved step navigate to ONBOARDING / SETUP / INFO
export default function Landing() {
  const [tokens] = savedTokens.useState(null)
  const [searchParams] = useSearchParams()
  const regToken = searchParams.get('regtoken')
  const setupuserPoolRegion = searchParams.get('setupuserPoolRegion')
  const setupuserPoolId = searchParams.get('setupuserPoolId')
  const setupuserPoolAppClientId = searchParams.get('setupuserPoolAppClientId')
  const code = searchParams.get('code')
  const state = searchParams.get('state')

  if (
    regToken &&
    setupuserPoolRegion &&
    setupuserPoolId &&
    setupuserPoolAppClientId
  ) {
    return <Navigate to={'marketplace?' + searchParams} replace />
  }

  if (code && state) {
    const url = new URL(state, window.location.origin)
    const params = queryString.parse(url.search)
    const query = queryString.stringify({ ...params, code })
    return <Navigate to={`${url.pathname}?${query}`} replace />
  }

  if (tokens) {
    return (
      <LoggedInNavigate
        username={tokens.username}
        organization={tokens.organization}
      />
    )
  }

  return (
    <>
      <Aside title="Provisioning" hideExtraRow />
      <Main>
        <ErrorNotLoggedIn />
      </Main>
    </>
  )
}
